import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IP_LOGIN_TOKEN_URL } from '@grid-ui/ip-login';
import { Observable, of, throwError } from 'rxjs';
import { catchError, delay } from 'rxjs/operators';
import { WindowUtilitiesService } from '../../../../shared-utilities/window-services/services';

export const URLS_EXCLUDED_LOGIN_REDIRECT_REGEX = [
  /fe-api\/analytics\/events/,
  /v4\/location\/delete-request/,
  /fe-api\/shared-link/,
  /fe-api\/feature-flag/,
  /api\/v3\/auth\/whoami\/user/,
  /api\/v3\/announcements/,
  /fe-api\/module-announcement/,
  /media\/public\/icons/,
  /api\/v4\/auth\/password-policy/,
  new RegExp(IP_LOGIN_TOKEN_URL),
];

@Injectable({ providedIn: 'root' })
export class HttpErrorInterceptor implements HttpInterceptor {
  private readonly windowUtilitiesService = inject(WindowUtilitiesService);

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const redirecting = this.checkError(error);

        if (redirecting) {
          // we need to return something to stop Angular cancelling the redirect, however we don't want it actioned on
          // therefore adding a very long delay (20 seconds) to ensure redirect is complete before observable emits
          return of({} as any).pipe(delay(20000));
        }

        return throwError(() => error);
      }),
    );
  }

  private checkError({ status, url }: HttpErrorResponse): boolean {
    const handledStatuses = [HttpStatusCode.Unauthorized, HttpStatusCode.Forbidden, HttpStatusCode.ServiceUnavailable];

    if (!handledStatuses.includes(status) || URLS_EXCLUDED_LOGIN_REDIRECT_REGEX.some((regex) => regex.test(url || ''))) {
      return false;
    }

    const fullPath = this.windowUtilitiesService.getFullPath();

    if (fullPath.startsWith('/accounts/')) {
      return false;
    }

    let redirectUrl: string;

    if (status === HttpStatusCode.Unauthorized) {
      const currentLocation = encodeURIComponent(fullPath);
      redirectUrl = '/accounts/login';

      if (currentLocation && currentLocation !== '%2F') {
        redirectUrl += `?next=${currentLocation}`;
      }
    } else if (status === HttpStatusCode.Forbidden) {
      redirectUrl = '/no-access.html';
    } else {
      redirectUrl = '/service-unavailable.html';
    }

    this.windowUtilitiesService.setHref(redirectUrl);
    return true;
  }
}
